<template>
  <v-app id="inspire" style="margin-left: 10%; margin-right: 10%;">
    <v-app-bar color="#364C9A" dark app fixed height="150%">
      <v-container>
        <v-row class="no-gutters">
          <!-- Logos -->
          <v-col cols="12" lg="12" class="d-flex justify-center">
            <v-img :src="require('@/assets/logo3_2.png')" max-height="100%" max-width="12%" contain style="margin-right: 20%;" class="presidencia"></v-img>
            <v-img :src="require('@/assets/logo-paco.svg')" max-height="100%" max-width="12%" contain style="margin-left: 10%; margin-right: 10%;" class="paco"></v-img>
            <v-img :src="require('@/assets/logo3_1.png')" max-height="100%" max-width="12%" contain style="margin-left: 20%;" class="transparencia"></v-img>
          </v-col>

          <!-- Desktop menu -->
          <v-col cols="12" lg="12" style="background-color: #364C9A;">
            <div class="d-none d-lg-flex justify-center">
              <v-btn text @click="navigateToInicio" color="white" style=" text-transform: none; font-size: 17px; font-family: 'Nunito Sans', sans-serif !important;">
                Inicio
              </v-btn>
              <v-btn text :to="{ name: 'home' }" color="white" style="text-transform: none; font-size: 17px; font-family: 'Nunito Sans', sans-serif !important;">
                EcoControl
              </v-btn>
              <v-btn text :to="{ name: 'casostotales' }" color="white" style="text-transform: none; font-size: 17px; font-family: 'Nunito Sans', sans-serif !important;">
                Banco Casos
              </v-btn>
              <v-btn text :to="{ name: 'controlsocial' }" color="white" style="text-transform: none; font-size: 17px; font-family: 'Nunito Sans', sans-serif !important;">
                Control Social
              </v-btn>
              <v-btn text :to="{ name: 'curso' }" color="white" style="text-transform: none; font-size: 17px; font-family: 'Nunito Sans', sans-serif !important;">
                Curso
              </v-btn>
              <v-btn text :to="{ name: 'autodig' }" color="white" style="text-transform: none; font-size: 17px; font-family: 'Nunito Sans', sans-serif !important;">
                Autodiagnóstico
              </v-btn>
              <v-btn text @click="navigateToDenuncie" color="#142e3c" style="background-color: #ffcd07; text-transform: none; font-size: 17px; font-family: 'Nunito Sans', sans-serif !important;">
                Denuncie
              </v-btn>
            </div>

            <!-- Mobile / Tablet Menu -->
            <div class="d-flex d-lg-none justify-end">
              <v-btn icon @click="drawer = !drawer" color="white" >
                <v-icon color="white" >menu</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>

    <!-- Drawer para móvil / tableta -->
    <v-navigation-drawer
      v-model="drawer"
      app
      temporary
      right
      color="#364C9A"
       
    >
      <v-list>
        <v-list-item @click="navigateToInicio" class="custom-list-item">
          <v-list-item-title style="color: white;" >Inicio</v-list-item-title>
        </v-list-item>
        <v-list-item :to="{ name: 'home' }" class="custom-list-item">
          <v-list-item-title style="color: white;">EcoControl</v-list-item-title>
        </v-list-item>
        <v-list-item :to="{ name: 'casostotales' }" class="custom-list-item">
          <v-list-item-title style="color: white;">Banco Casos</v-list-item-title>
        </v-list-item>
        <v-list-item :to="{ name: 'controlsocial' }" class="custom-list-item">
          <v-list-item-title style="color: white;">Control Social</v-list-item-title>
        </v-list-item>
        <v-list-item :to="{ name: 'curso' }" class="custom-list-item">
          <v-list-item-title style="color: white;" >Curso</v-list-item-title>
        </v-list-item>
        <v-list-item :to="{ name: 'autodig' }" class="custom-list-item">
          <v-list-item-title style="color: white;">Autodiagnóstico</v-list-item-title>
        </v-list-item>
        <v-list-item @click="navigateToDenuncie" style="background-color: #ffcd07;">
          <v-list-item-title style="color:#142e3c; font-weight:bold;  ">Denuncie</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-main>
      <SectionTitle :title="currentTitle" :image="currentImage" />
      <v-container fluid fill-height>
        <v-slide-y-transition mode="out-in">
          <router-view />
        </v-slide-y-transition>
      </v-container>
    </v-main>

    <br><br><br><br>

    <!-- Footer -->
    <div class="footer-container">
      <div color="white" dark height="auto">
        <div style="color: white" class="text-center">
          <v-row>
            <v-col cols="12" lg="12" style="background-color: rgb(0, 49, 137); border-radius: 8px;">
              &copy;Desarrollado por el equipo de ITS - UNODC ROCOL - 2024 CODA - Versión 1.0.0.1 Privacy
            </v-col>
            <v-col cols="12" lg="12" class="d-flex justify-center align-center" style="flex-wrap: wrap;">
              <v-img :src="require('@/assets/logo2_4.png')" max-height="40" max-width="300" contain></v-img>
              <v-img :src="require('@/assets/logo2_3.jpg')" max-height="80" max-width="400" contain></v-img>
              <v-img :src="require('@/assets/logo2_2.png')" max-height="100" max-width="400" contain></v-img>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>
  </v-app>
</template>

<script>
import SectionTitle from '@/components/SectionTitle.vue';
//import SectionFooter from '@/components/SectionFooter.vue';

export default {
  name: "App",
  components: {
    SectionTitle,
    //SectionFooter
  },
  data() {
    return {
      clipped: false,
      drawer: false,
      fixed: false,
      items: [
        {
          icon: "bubble_chart",
          title: "Inspire",
        },
      ],
      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: "Vuetify.js",
      currentTitle: 'Inicio', // valor inicial del título
      currentImage: require('@/assets/banner1.jpg'), // valor inicial de la imagen
      sectionTitles: {
        home: 'Inicio',
        bancocaso: 'Banco Casos',
        controlsocial: 'Control Social',
        curso: 'Curso',
        autodig: 'Autodiagnóstico',
        about: 'ABOUT',
        detallecaso: 'DETALLE CASO',
        casostot: 'Banco Casos',
        casostotales: 'Banco Casos',
      },
      sectionImages: {
        home: require('@/assets/banner1.jpg'),
        bancocaso: require('@/assets/banner2.jpg'),
        controlsocial: require('@/assets/banner5.jpg'),
        curso: require('@/assets/banner3.jpg'),
        autodig: require('@/assets/banner4.jpg'),
        about: require('@/assets/banner5.jpg'),
        detallecaso: require('@/assets/banner5.jpg'),
        casostot: require('@/assets/banner5.jpg'),
        casostotales: require('@/assets/banner2.jpg'),
      },
    };
  },
  computed: {
    /*currentTitle() {
      const routeName = this.$route.name;
      return this.sectionTitles[routeName] || 'INICIO';
    }*/
  },
  watch: {
    $route(to, from) {
      // Actualizar el título y la imagen según la ruta actual
      this.currentTitle = this.sectionTitles[to.name] || 'INICIO';
      this.currentImage = this.sectionImages[to.name] || require('@/assets/banner1.jpg');
    }
  },
  methods: {
    navigateToInicio() {
      window.location.href = "https://portal.paco.gov.co/index.php?pagina=inicio";
    },
    navigateToDenuncie() {
      window.location.href = "https://portal.paco.gov.co/index.php?pagina=denuncie";
    }
  }
};
</script>
<style scoped>
  .footer-container {
    border: 2px solid rgb(0, 30, 67);
    padding: 10px;
    margin: 20px;
    border-radius: 8px;
    margin-left: -8%; 
    margin-right: -8%;
  }  
  .v-toolbar-title {
    font-size: 1.5rem;
    font-weight: bold;
  }

  @media (min-width: 640px) and (max-width: 641px){

.presidencia{
max-width: 20% !important;
margin-right: 3% !important;
margin-left: 0 !important;
}

.paco{
max-width: 20% !important;
margin-right: 3% !important;
margin-left: 0 !important;
}

.transparencia{
max-width: 20% !important;
margin-left: 3% !important;

}

}

@media (min-width: 375px) and (max-width: 376px){

.presidencia{
max-width: 30% !important;
margin-right: 3% !important;
margin-left: 0 !important;
}

.paco{
max-width: 30% !important;
margin-right: 3% !important;
margin-left: 0 !important;
}

.transparencia{
max-width: 30% !important;
margin-left: 3% !important;

}

.columna > a{

  flex: 0 0 100%;   
  max-width: 100%;
}



}

@media (min-width: 414px) and (max-width: 415px){

.presidencia{
max-width: 30% !important;
margin-right: 3% !important;
margin-left: 0% !important;
}

.paco{
max-width: 30% !important;
margin-right: 3% !important;
margin-left: 0 !important;
}

.transparencia{
max-width: 30% !important;
margin-left: 3% !important;

}

}

@media (min-width: 390px) and (max-width: 391px){

.presidencia{
max-width: 30% !important;
margin-right: 3% !important;
margin-left: 0% !important;
}

.paco{
max-width: 30% !important;
margin-right: 3% !important;
margin-left: 0 !important;
}

.transparencia{
max-width: 30% !important;
margin-left: 3% !important;

}

}


@media (min-width: 430px) and (max-width: 431px){

.presidencia{
max-width: 30% !important;
margin-right: 3% !important;
margin-left: 0% !important;
}

.paco{
max-width: 30% !important;
margin-right: 3% !important;
margin-left: 0 !important;
}

.transparencia{
max-width: 30% !important;
margin-left: 3% !important;

}

}

@media (min-width: 412px) and (max-width: 413px){

.presidencia{
max-width: 30% !important;
margin-right: 3% !important;
margin-left: 0% !important;
}

.paco{
max-width: 30% !important;
margin-right: 3% !important;
margin-left: 0 !important;
}

.transparencia{
max-width: 30% !important;
margin-left: 3% !important;

}

}

@media (min-width: 360px) and (max-width: 361px){

.presidencia{
max-width: 30% !important;
margin-right: 3% !important;
margin-left: 0% !important;
}

.paco{
max-width: 30% !important;
margin-right: 3% !important;
margin-left: 0 !important;
}

.transparencia{
max-width: 30% !important;
margin-left: 3% !important;

}

}

@media (min-width: 768px) and (max-width: 769px){

.presidencia{
max-width: 20% !important;
margin-right: 3% !important;
margin-left: 0% !important;
}

.paco{
max-width: 20% !important;
margin-right: 3% !important;
margin-left: 0 !important;
}

.transparencia{
max-width: 20% !important;
margin-left: 3% !important;

}

}

@media (min-width: 820px) and (max-width: 821px){

.presidencia{
max-width: 20% !important;
margin-right: 3% !important;
margin-left: 0% !important;
}

.paco{
max-width: 20% !important;
margin-right: 3% !important;
margin-left: 0 !important;
}

.transparencia{
max-width: 20% !important;
margin-left: 3% !important;

}

}

@media (min-width: 1024px) and (max-width: 1025px){

.presidencia{
max-width: 20% !important;
margin-right: 3% !important;
margin-left: 0% !important;
}

.paco{
max-width: 20% !important;
margin-right: 3% !important;
margin-left: 0 !important;
}

.transparencia{
max-width: 20% !important;
margin-left: 3% !important;

}

}

@media (min-width: 912px) and (max-width: 913px){

.presidencia{
max-width: 20% !important;
margin-right: 3% !important;
margin-left: 0% !important;
}

.paco{
max-width: 20% !important;
margin-right: 3% !important;
margin-left: 0 !important;
}

.transparencia{
max-width: 20% !important;
margin-left: 3% !important;

}

}


@media (min-width: 540px) and (max-width: 541px){

.presidencia{
max-width: 20% !important;
margin-right: 3% !important;
margin-left: 0% !important;
}

.paco{
max-width: 20% !important;
margin-right: 3% !important;
margin-left: 0 !important;
}

.transparencia{
max-width: 20% !important;
margin-left: 3% !important;

}

}

@media (min-width: 344px) and (max-width: 345px){

.presidencia{
max-width: 30% !important;
margin-right: 3% !important;
margin-left: 0% !important;
}

.paco{
max-width: 30% !important;
margin-right: 3% !important;
margin-left: 0 !important;
}

.transparencia{
max-width: 30% !important;
margin-left: 3% !important;

}

}

@media (min-width: 853px) and (max-width: 854px){

.presidencia{
max-width: 18% !important;
margin-right: 3% !important;
margin-left: 0% !important;
}

.paco{
max-width: 18% !important;
margin-right: 3% !important;
margin-left: 0 !important;
}

.transparencia{
max-width: 18% !important;
margin-left: 3% !important;

}

}





</style>

